import CustomTable from "../../../components/CustomTable/CustomTable";
import ColumnSettingsDropdown from "../../../components/CustomTable/ColumnSettingsDropdown";
import { Flex, Input } from "antd";
import { useSelector, useDispatch } from "react-redux";
import useSearchableTable from "../../../hooks/useSearchableTable";
import {
    getUsersWallet,
    getBusEntWallet,
    getKarncyWallets,
} from "../../../redux/slices/walletsSlice";
import { useEffect, useMemo, useState } from "react";
import { getWalletColumns } from "./getWalletColumns";
import { useNavigate } from "react-router-dom";
import {
  TABLE_COLUMN_DEFAULTS,
  buildTableScreenKey,
} from "../../../constants/tableColumnDefaults";

const WalletsTable = ({ data, tabIndex }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading } = useSelector((state) => state?.wallets);
    const { searchText, setSearchText, filteredData } = useSearchableTable(data);
    const [columnControl, setColumnControl] = useState(null);

    const screenKey = useMemo(
        () => buildTableScreenKey("wallets", String(tabIndex)),
        [tabIndex],
    );

    useEffect(() => {
        if (tabIndex === 1) dispatch(getUsersWallet());
        else if (tabIndex === 2) dispatch(getBusEntWallet());
        else if (tabIndex === 4) dispatch(getKarncyWallets());
    }, [dispatch, tabIndex]);

    const columns = useMemo(
        () =>
            getWalletColumns({
                tabIndex,
                onView: (record) => navigate(`/wallets/wallet-detail`, { state: { walletInfo: record,tabIndex } }),
            }),
        [tabIndex, navigate]
    );

    return (
        <>
            <Flex
                gap={8}
                justify="flex-end"
                align="center"
                className="table-toolbar-controls"
                style={{ marginRight: 20, marginBottom: 15 }}
            >
                {columnControl && (
                    <ColumnSettingsDropdown
                        availableOptions={columnControl.availableOptions}
                        visibleOrderedKeys={columnControl.visibleOrderedKeys}
                        onToggleColumn={columnControl.onToggleColumn}
                        onToggleAll={columnControl.onToggleAll}
                        onReorder={columnControl.onReorder}
                        onReset={columnControl.onReset}
                        loading={columnControl.loading}
                        saving={columnControl.saving}
                        isCustomized={columnControl.isCustomized}
                    />
                )}
                <Input
                    placeholder="Search"
                    allowClear
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    className="search-input"
                    style={{ width: 250 }}
                />
            </Flex>
            <CustomTable
                rowKey="vaAccountId"
                columns={columns}
                dataSource={filteredData}
                loading={loading}
                screenKey={screenKey}
                defaultColumnKeys={TABLE_COLUMN_DEFAULTS.wallets}
                onColumnControlChange={setColumnControl}
            />
        </>
    );
};

export default WalletsTable;
